import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.swingsetupai.com/api';

const apiClient = axios.create({ baseURL: API_BASE_URL });

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export interface ChartPatternType {
  id: number;
  code: string;
  name: string;
  description: string;
  category: 'REVERSAL' | 'CONTINUATION';
  imageUrl: string | null;
  isActive: boolean;
  sortOrder: number;
  chartinkScreenerId: string | null;
}

export interface ChartPatternResult {
  id: number;
  patternId: number;
  patternCode: string;
  patternName: string;
  symbol: string;
  companyName: string;
  exchange: string;
  sector: string;
  industry: string;
  timeframe: 'DAILY' | 'WEEKLY' | 'MONTHLY';
  closePrice: number;
  changePct: number;
  volume: number;
  marketCap: number;
  marketCapName: 'MICROCAP' | 'SMALLCAP' | 'MIDCAP' | 'LARGECAP';
  asOfDate: string;
}

export interface ChartPatternFilters {
  patternCode?: string;
  timeframe?: string;
  marketCapName?: string;
  marketCapMin?: number;
  marketCapMax?: number;
  sector?: string;
}

export const fetchPatternTypes = (): Promise<ChartPatternType[]> =>
  apiClient.get('/chart-patterns/types').then(r => r.data?.data ?? r.data);

export const fetchPatternResults = (filters: ChartPatternFilters): Promise<ChartPatternResult[]> =>
  apiClient.get('/chart-patterns/results', { params: filters }).then(r => {
    const body = r.data;
    console.log('[chartPatternResults]', body);
    if (Array.isArray(body)) return body;
    if (Array.isArray(body?.data)) return body.data;
    return [];
  });

export const fetchPatternSectors = (): Promise<string[]> =>
  apiClient.get('/chart-patterns/sectors').then(r => r.data?.data ?? r.data);
